import React from 'react'
import BrandLogo from './BrandLogo'
import { isChunkLoadError, reloadOnceForNewDeploy } from '../utils/chunkReload'

/**
 * Catches render crashes and failed route chunks so the app never goes blank.
 * `resetKey` clears the error when it changes (e.g. on navigation).
 */
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('[app] render error:', error, info?.componentStack)
    if (isChunkLoadError(error)) reloadOnceForNewDeploy()
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null })
    }
  }

  render() {
    if (!this.state.error) return this.props.children
    const fullScreen = this.props.fullScreen !== false
    return (
      <div
        role="alert"
        className={`${fullScreen ? 'min-h-screen' : 'min-h-[60vh]'} bg-ink text-ivory flex flex-col items-center justify-center gap-6 px-6 text-center`}
      >
        <BrandLogo size="loading" />
        <div className="space-y-2">
          <h1 className="font-serif text-3xl sm:text-4xl">Something went wrong</h1>
          <p className="text-sm text-ivory-muted max-w-sm">
            This page didn't load properly. Reloading usually fixes it.
          </p>
        </div>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="px-6 py-3 rounded-full bg-ivory text-ink text-sm font-semibold hover:bg-white transition-colors"
        >
          Reload
        </button>
      </div>
    )
  }
}
